"use strict";
/**
 * These helpers provide a (albeit inflexible) DSL for writing function
 * definitions for the SPARQL functions.
 */

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _slicedToArray = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var E = require("../expressions");

var C = require("../util/Consts");

var Err = require("../util/Errors");

var Consts_1 = require("../util/Consts");

var Core_1 = require("./Core");

function declare() {
  return new Builder();
}

exports.declare = declare;

var Builder =
/*#__PURE__*/
function () {
  function Builder() {
    _classCallCheck(this, Builder);

    this.implementations = [];
  }

  _createClass(Builder, [{
    key: "collect",
    value: function collect() {
      return map(this.implementations);
    }
  }, {
    key: "log",
    value: function log() {
      // tslint:disable-next-line:no-console
      console.log(this.implementations);
      return this;
    }
  }, {
    key: "add",
    value: function add(impl) {
      this.implementations.push(impl);
      return this;
    }
  }, {
    key: "set",
    value: function set(argTypes, func) {
      var types = immutable_1.List(argTypes);
      return this.add(new Impl({
        types: types,
        func: func
      }));
    }
  }, {
    key: "copy",
    value: function copy(_ref) {
      var from = _ref.from,
          to = _ref.to;
      var last = this.implementations.length - 1;

      var _from = immutable_1.List(from);

      for (var i = last; i >= 0; i--) {
        var impl = this.implementations[i];

        if (impl.get('types').equals(_from)) {
          return this.set(to, impl.get('func'));
        }
      }

      throw new Err.UnexpectedError('Tried to copy implementation, but types not found', {
        from: from,
        to: to
      });
    }
  }, {
    key: "onUnary",
    value: function onUnary(type, op) {
      return this.set([type], function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 1),
            val = _ref3[0];

        return op(val);
      });
    }
  }, {
    key: "onUnaryTyped",
    value: function onUnaryTyped(type, op) {
      return this.set([type], function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 1),
            val = _ref5[0];

        return op(val.typedValue);
      });
    }
  }, {
    key: "onBinary",
    value: function onBinary(types, op) {
      return this.set(types, function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 2),
            left = _ref7[0],
            right = _ref7[1];

        return op(left, right);
      });
    }
  }, {
    key: "onBinaryTyped",
    value: function onBinaryTyped(types, op) {
      return this.set(types, function (_ref8) {
        var _ref9 = _slicedToArray(_ref8, 2),
            left = _ref9[0],
            right = _ref9[1];

        return op(left.typedValue, right.typedValue);
      });
    }
  }, {
    key: "onTernaryTyped",
    value: function onTernaryTyped(types, op) {
      return this.set(types, function (_ref10) {
        var _ref11 = _slicedToArray(_ref10, 3),
            a1 = _ref11[0],
            a2 = _ref11[1],
            a3 = _ref11[2];

        return op(a1.typedValue, a2.typedValue, a3.typedValue);
      });
    }
  }, {
    key: "onTernary",
    value: function onTernary(types, op) {
      return this.set(types, function (_ref12) {
        var _ref13 = _slicedToArray(_ref12, 3),
            a1 = _ref13[0],
            a2 = _ref13[1],
            a3 = _ref13[2];

        return op(a1, a2, a3);
      });
    }
  }, {
    key: "onQuaternaryTyped",
    value: function onQuaternaryTyped(types, op) {
      return this.set(types, function (_ref14) {
        var _ref15 = _slicedToArray(_ref14, 4),
            a1 = _ref15[0],
            a2 = _ref15[1],
            a3 = _ref15[2],
            a4 = _ref15[3];

        return op(a1.typedValue, a2.typedValue, a3.typedValue, a4.typedValue);
      });
    }
  }, {
    key: "unimplemented",
    value: function unimplemented(msg) {
      for (var arity = 0; arity <= 5; arity++) {
        var types = Array(arity).fill('term');

        var func = function func(_args) {
          throw new Err.UnimplementedError(msg);
        };

        this.set(types, func);
      }

      return this;
    }
  }, {
    key: "onTerm1",
    value: function onTerm1(op) {
      return this.set(['term'], function (_ref16) {
        var _ref17 = _slicedToArray(_ref16, 1),
            term = _ref17[0];

        return op(term);
      });
    }
  }, {
    key: "onLiteral1",
    value: function onLiteral1(op) {
      return this.set(['literal'], function (_ref18) {
        var _ref19 = _slicedToArray(_ref18, 1),
            term = _ref19[0];

        return op(term);
      });
    }
  }, {
    key: "onBoolean1",
    value: function onBoolean1(op) {
      return this.set(['boolean'], function (_ref20) {
        var _ref21 = _slicedToArray(_ref20, 1),
            lit = _ref21[0];

        return op(lit);
      });
    }
  }, {
    key: "onBoolean1Typed",
    value: function onBoolean1Typed(op) {
      return this.set(['boolean'], function (_ref22) {
        var _ref23 = _slicedToArray(_ref22, 1),
            lit = _ref23[0];

        return op(lit.typedValue);
      });
    }
  }, {
    key: "onString1",
    value: function onString1(op) {
      return this.set(['string'], function (_ref24) {
        var _ref25 = _slicedToArray(_ref24, 1),
            lit = _ref25[0];

        return op(lit);
      });
    }
  }, {
    key: "onString1Typed",
    value: function onString1Typed(op) {
      return this.set(['string'], function (_ref26) {
        var _ref27 = _slicedToArray(_ref26, 1),
            lit = _ref27[0];

        return op(lit.typedValue);
      });
    }
  }, {
    key: "onLangString1",
    value: function onLangString1(op) {
      return this.set(['langString'], function (_ref28) {
        var _ref29 = _slicedToArray(_ref28, 1),
            lit = _ref29[0];

        return op(lit);
      });
    }
  }, {
    key: "onStringly1",
    value: function onStringly1(op) {
      return this.set(['string'], function (_ref30) {
        var _ref31 = _slicedToArray(_ref30, 1),
            lit = _ref31[0];

        return op(lit);
      }).set(['langString'], function (_ref32) {
        var _ref33 = _slicedToArray(_ref32, 1),
            lit = _ref33[0];

        return op(lit);
      });
    }
  }, {
    key: "onStringly1Typed",
    value: function onStringly1Typed(op) {
      return this.set(['string'], function (_ref34) {
        var _ref35 = _slicedToArray(_ref34, 1),
            lit = _ref35[0];

        return op(lit.typedValue);
      }).set(['langString'], function (_ref36) {
        var _ref37 = _slicedToArray(_ref36, 1),
            lit = _ref37[0];

        return op(lit.typedValue);
      });
    }
  }, {
    key: "onNumeric1",
    value: function onNumeric1(op) {
      return this.set(['integer'], function (_ref38) {
        var _ref39 = _slicedToArray(_ref38, 1),
            val = _ref39[0];

        return op(val);
      }).set(['decimal'], function (_ref40) {
        var _ref41 = _slicedToArray(_ref40, 1),
            val = _ref41[0];

        return op(val);
      }).set(['float'], function (_ref42) {
        var _ref43 = _slicedToArray(_ref42, 1),
            val = _ref43[0];

        return op(val);
      }).set(['double'], function (_ref44) {
        var _ref45 = _slicedToArray(_ref44, 1),
            val = _ref45[0];

        return op(val);
      }).invalidLexicalForm(['nonlexical'], 1);
    }
  }, {
    key: "onDateTime1",
    value: function onDateTime1(op) {
      return this.set(['date'], function (_ref46) {
        var _ref47 = _slicedToArray(_ref46, 1),
            val = _ref47[0];

        return op(val);
      }).invalidLexicalForm(['nonlexical'], 1);
    }
    /**
     * Arithmetic operators take 2 numeric arguments, and return a single numerical
     * value. The type of the return value is heavily dependant on the types of the
     * input arguments. In JS everything is a double, but in SPARQL it is not.
     *
     * {@link https://www.w3.org/TR/sparql11-query/#OperatorMapping}
     * {@link https://www.w3.org/TR/xpath-functions/#op.numeric}
     *
     * @param op the (simple) binary mathematical operator that
     */

  }, {
    key: "arithmetic",
    value: function arithmetic(op) {
      return this.numeric(function (_ref48) {
        var _ref49 = _slicedToArray(_ref48, 2),
            left = _ref49[0],
            right = _ref49[1];

        var promotionType = Core_1.promote(left.type, right.type);
        var resultType = C.decategorize(promotionType);
        return number(op(left.typedValue, right.typedValue), resultType);
      });
    }
  }, {
    key: "numberTest",
    value: function numberTest(test) {
      return this.numeric(function (_ref50) {
        var _ref51 = _slicedToArray(_ref50, 2),
            left = _ref51[0],
            right = _ref51[1];

        var result = test(left.typedValue, right.typedValue);
        return bool(result);
      });
    }
  }, {
    key: "stringTest",
    value: function stringTest(test) {
      return this.set(['string', 'string'], function (_ref52) {
        var _ref53 = _slicedToArray(_ref52, 2),
            left = _ref53[0],
            right = _ref53[1];

        var result = test(left.typedValue, right.typedValue);
        return bool(result);
      }).invalidLexicalForm(['nonlexical', 'string'], 1).invalidLexicalForm(['string', 'nonlexical'], 2);
    }
  }, {
    key: "booleanTest",
    value: function booleanTest(test) {
      return this.set(['boolean', 'boolean'], function (_ref54) {
        var _ref55 = _slicedToArray(_ref54, 2),
            left = _ref55[0],
            right = _ref55[1];

        var result = test(left.typedValue, right.typedValue);
        return bool(result);
      }).invalidLexicalForm(['nonlexical', 'boolean'], 1).invalidLexicalForm(['boolean', 'nonlexical'], 2);
    }
  }, {
    key: "dateTimeTest",
    value: function dateTimeTest(test) {
      return this.set(['date', 'date'], function (_ref56) {
        var _ref57 = _slicedToArray(_ref56, 2),
            left = _ref57[0],
            right = _ref57[1];

        var result = test(left.typedValue, right.typedValue);
        return bool(result);
      }).invalidLexicalForm(['nonlexical', 'date'], 1).invalidLexicalForm(['date', 'nonlexical'], 2);
    }
  }, {
    key: "numeric",
    value: function numeric(op) {
      return this.set(['integer', 'integer'], op).set(['integer', 'decimal'], op).set(['integer', 'float'], op).set(['integer', 'double'], op).invalidLexicalForm(['integer', 'nonlexical'], 2).set(['decimal', 'integer'], op).set(['decimal', 'decimal'], op).set(['decimal', 'float'], op).set(['decimal', 'double'], op).invalidLexicalForm(['decimal', 'nonlexical'], 2).set(['float', 'integer'], op).set(['float', 'decimal'], op).set(['float', 'float'], op).set(['float', 'double'], op).invalidLexicalForm(['float', 'nonlexical'], 2).set(['double', 'integer'], op).set(['double', 'decimal'], op).set(['double', 'float'], op).set(['double', 'double'], op).invalidLexicalForm(['double', 'nonlexical'], 2).invalidLexicalForm(['nonlexical', 'integer'], 1).invalidLexicalForm(['nonlexical', 'decimal'], 1).invalidLexicalForm(['nonlexical', 'float'], 1).invalidLexicalForm(['nonlexical', 'double'], 1);
    }
  }, {
    key: "invalidLexicalForm",
    value: function invalidLexicalForm(types, index) {
      return this.set(types, function (args) {
        throw new Err.InvalidLexicalForm(args[index - 1].toRDF());
      });
    }
  }, {
    key: "chain",
    value: function chain(impls) {
      this.implementations = this.implementations.concat(impls);
      return this;
    }
  }]);

  return Builder;
}();

exports.Builder = Builder;
var implDefaults = {
  types: [],
  func: function func() {
    var msg = 'Implementation not set yet declared as implemented';
    throw new Err.UnexpectedError(msg);
  }
};

var Impl =
/*#__PURE__*/
function (_immutable_1$Record) {
  _inherits(Impl, _immutable_1$Record);

  function Impl(params) {
    _classCallCheck(this, Impl);

    return _possibleConstructorReturn(this, _getPrototypeOf(Impl).call(this, params));
  }

  _createClass(Impl, [{
    key: "get",
    value: function get(value) {
      return _get(_getPrototypeOf(Impl.prototype), "get", this).call(this, value);
    }
  }, {
    key: "toPair",
    value: function toPair() {
      return [this.get('types'), this.get('func')];
    }
  }]);

  return Impl;
}(immutable_1.Record(implDefaults));

exports.Impl = Impl;

function map(implementations) {
  var typeImplPair = implementations.map(function (i) {
    return i.toPair();
  });
  return immutable_1.Map(typeImplPair);
}

exports.map = map; // ----------------------------------------------------------------------------
// Literal Construction helpers
// ----------------------------------------------------------------------------

function bool(val) {
  return new E.BooleanLiteral(val);
}

exports.bool = bool;

function number(num, dt) {
  return new E.NumericLiteral(num, C.make(dt || Consts_1.TypeURL.XSD_FLOAT), undefined);
}

exports.number = number;

function numberFromString(str, dt) {
  var num = Number(str);
  return new E.NumericLiteral(num, C.make(dt || Consts_1.TypeURL.XSD_FLOAT), undefined);
}

exports.numberFromString = numberFromString;

function string(s) {
  return new E.StringLiteral(s);
}

exports.string = string;

function langString(s, lang) {
  return new E.LangStringLiteral(s, lang);
}

exports.langString = langString;

function dateTime(date, str) {
  return new E.DateTimeLiteral(date, str);
}

exports.dateTime = dateTime; // ----------------------------------------------------------------------------
// Util
// ----------------------------------------------------------------------------
// tslint:disable-next-line:no-any

function log(val) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  // tslint:disable-next-line:no-console
  console.log(val, args);
  return val;
}

exports.log = log;

function typeCheckLit(term, allowed, args, op) {
  if (term.termType !== 'literal') {
    throw new Err.InvalidArgumentTypes(args, op);
  } // tslint:disable-next-line:no-any


  var lit = term;

  if (!allowed.includes(lit.type)) {
    throw new Err.InvalidArgumentTypes(args, op);
  }

  return lit;
}

exports.typeCheckLit = typeCheckLit;